/* eslint-disable no-unused-vars */
import { useMemo, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Typography } from '@mui/material';
import SectionLayout from 'components/common/SectionLayout';
import { Bid } from 'components';
import { select_current_campaign_obj, isAdminSelector } from 'store/selectors';
import { generalActions, formErrorsCampaign_action } from 'store/actions';
import { isBidErrorShown, trimDecimal } from 'utils';
import * as S from './BiddingSection.styled';

function validateBid(bid, minBid, maxBid, serverMsg) {
  let errMsg = '';

  if (bid === '') {
    errMsg = 'This field is required!! The value cannot be less than the minimum';
  } else if (bid < minBid || bid === '.') {
    // bidValueErrorMessage happens when there are some more
    // precise recommendations that comes from /CheckFactorBid request
    errMsg = serverMsg || `Bid must be at least $${minBid}`;
  } else if (bid > maxBid) {
    errMsg = 'Your bid is too high';
  }

  return errMsg;
}

export const BidValue = ({
  isAdmin,
  minBidValueStore,
  // isOpen,
  minBidValue,
  maxBidValue,
  isCpm,
}) => {
  const dispatch = useDispatch();
  const changeFlag = useRef(false);

  const bidValueErrorMessage = useSelector((state) => state.general.bidErrorMessage);
  const currentCampaignObj = useSelector(select_current_campaign_obj);

  const bidValue = currentCampaignObj.bid || '';

  const isError = isBidErrorShown(bidValue, minBidValue, maxBidValue); // isOpen && isBidErrorShown(bidValue, minBidValue, maxBidValue);
  const minForError = isCpm ? minBidValue : isAdmin ? minBidValueStore : minBidValue;
  const errorText = useMemo(
    () => validateBid(bidValue, minForError, maxBidValue, bidValueErrorMessage),
    [bidValue, minForError, maxBidValue, bidValueErrorMessage],
  );

  function handleBidChange(e) {
    if (!changeFlag?.current) {
      changeFlag.current = true;
    }

    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: 'bid',
        newValue: trimDecimal(e.target.value, isCpm),
      }),
    );
  }

  function handleBlur(e) {
    const currentBid = e.target.value;
    if (currentBid.startsWith('.')) {
      const formatedBid = '0' + currentBid;

      dispatch(
        generalActions.updateCurrentCampaignObj({
          propField: 'bid',
          newValue: trimDecimal(formatedBid, isCpm),
        }),
      );
    }
  }

  // to show actuall minimum for admin users
  const minBidHintText = isCpm ? minBidValue : isAdmin ? minBidValueStore : minBidValue;

  return (
    <SectionLayout
      leftSide={
        <>
          <Typography variant='subtitle2'>Bid:</Typography>
          <Typography variant='subtitle1'>Minimum ${minBidHintText}</Typography>
        </>
      }
      rightSide={
        <S.BidContainer>
          <Bid.Big
            error={
              (isAdmin && !!errorText) ||
              (changeFlag?.current && isError) ||
              // (changeFlag?.current && !bidValue && isAdmin) ||
              (!changeFlag?.current && bidValue !== '' && isError)
            }
            errorMesage={errorText}
            label=''
            value={bidValue ?? ''}
            onChange={handleBidChange}
            onBlur={handleBlur}
          />
        </S.BidContainer>
      }
    />
  );
};
